module.exports = __webpack_public_path__ + "static/media/close-cross-white.74d4ae9a.svg";